module.exports = __webpack_public_path__ + "img/ELandlethbridge.14eaf8fc.png";